import { render, staticRenderFns } from "./Onboarding.container.vue?vue&type=template&id=3a01df2c&scoped=true&"
import script from "./Onboarding.container.vue?vue&type=script&lang=ts&"
export * from "./Onboarding.container.vue?vue&type=script&lang=ts&"
import style0 from "./Onboarding.container.vue?vue&type=style&index=0&id=3a01df2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a01df2c",
  null
  
)

export default component.exports